import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rakhi-making-competition',
  templateUrl: './rakhi-making-competition.component.html',
  styleUrls: ['./rakhi-making-competition.component.scss']
})
export class RakhiMakingCompetitionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
